// errors.ts

export function handleGetDiscordUserActivityError(error: any) {
  console.error('Failed to fetch Discord user activity:', error);
  // Vous pouvez ajouter plus de logique ici, par exemple afficher une notification ou formater l'erreur
}
